
// Only supported in browsers
export default self.crypto;
